import { render } from "./facebook.vue?vue&type=template&id=7432fa88"
import script from "./facebook.vue?vue&type=script&lang=js"
export * from "./facebook.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/resources/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__